module.exports = __webpack_public_path__ + "aa75e32c78fc16a6e7bcedf220172a55.png";